import styled, { css } from 'styled-components'
import palette from '../../../../theme/palette'

export const Input = styled.div<{ disabled?: boolean, $hidden?: boolean, colorScheme?: string, withBackground?: boolean }>`
  width: 100%;
  position: relative;
  border-bottom: 1px solid ${palette.grayscale[200]};
  color: black;
  
  ${({ $hidden }) => $hidden && css`
    border-bottom: none;
  `}

  ${({ disabled }) => disabled && css`
    opacity: 0.5;
    
    input {
      cursor: not-allowed;
    }
  `}

  input {
    -webkit-appearance: none;
    appearance: none;
    width: 100%;
    height: ${({ theme }) => theme.rem(40)};
    border: none;
    background-color: transparent;
    ${({ theme }) => theme.typo('buttonMD')};
    padding: ${({ theme }) => theme.rem(0, 8)};
    color: ${({ theme, colorScheme, withBackground }) => withBackground ? theme.colorScheme[`${colorScheme}`].surface.text.base.negative : 'black'};

    &:focus {
      &::placeholder {
        opacity: 0;
      }
    }
  }

  div[data-lastpass-icon-root] {
    & + div {
      right: ${({ theme }) => theme.rem(10)}!important;
    }
  }
`

export const InputError = styled.div`
  padding-top: ${({ theme }) => theme.rem(8)};
  color: ${({ theme }) =>theme.colors.status.error.default};
  font-size: ${({ theme }) => theme.rem(12)};
`

export const InputToggleShow = styled.button`
  position: absolute;
  right: ${({ theme }) => theme.rem(16)};
  bottom: ${({ theme }) => theme.rem(10)};
  cursor: pointer;
  display: flex;
  align-items: center;
  background: none;
  border: none;
  padding: 0;
  color: inherit;

  i {
    font-size: ${({ theme }) => theme.rem(16)};
  }
`

export const InputLabel = styled.label`
  display: block;
  font-size: ${({ theme }) => theme.rem(11)};
  line-height: ${({ theme }) => theme.rem(11)};
  margin-bottom: ${({ theme }) => theme.rem(10)};
  font-weight: bold;
`

export const InputCorrectFeedback = styled.div`
  color: ${({ theme }) => theme.colors.status.success.default};
  position: absolute;
  right: ${({ theme }) => theme.rem(4)};
  bottom: ${({ theme }) => theme.rem(8)};

  i {
    font-size: ${({ theme }) => theme.rem(18)};
  }
`

export const InputHelperText = styled.div<{ colorScheme?: string, withBackground?: boolean }>`
  padding-top: ${({ theme }) => theme.rem(8)};
  font-size: ${({ theme }) => theme.rem(12)};
  color: ${({ theme, colorScheme, withBackground }) => withBackground ? theme.colorScheme[`${colorScheme}`].surface.text.base.negative : 'black'};
`